module.exports = __webpack_public_path__ + "img/education.ddc97c59.svg";